<p>Are you sure you want to delete?</p>
<div mat-dialog-actions>
  <button mat-stroked-button style="color: currentColor" (click)="onNoClick()">No</button>
  <button mat-flat-button class="delete" (click)="onYesClick()">Yes</button>
</div>
